// extracted by mini-css-extract-plugin
export default {"label":"BreadcrumbLabel_label__zt8Be","active":"BreadcrumbLabel_active__DofX7","noEllipsis":"BreadcrumbLabel_noEllipsis__5ApDG"};